import { types } from 'mobx-state-tree';


const FOUNDATION_TYPES = {
    BASEMENT: 'basement',
    CRAWLSPACE: 'crawlspace',
    PIER: 'pier',
    SLAB_ON_GRADE: 'slab_on_Grade',
    WALKOUT_BASEMENT: 'walkout_basement',
};

const FoundationTypeEnum = types.enumeration('FoundationType', Object.values(FOUNDATION_TYPES));

export {
    FoundationTypeEnum,
};
export default FOUNDATION_TYPES;
